import { withProps } from 'recompose';
import { TextField } from '@material-ui/core';
import Range from './range';

export default withProps(() => ({ component: TextField }))(Range);
